// extracted by mini-css-extract-plugin
module.exports = {"screenreaderonly":"ga4JpI","clearfix":"_3mJCgn","group":"_3INcte","heading":"DKzxPe","hiddenTabSelector":"eXo7r4","content":"_2aDcIF"};